import { ReactNode } from "react";

import { ScrollArea } from "@/components/ui/scroll-area.tsx";
import { HelpPopup } from "@/features/help/views/HelpPopup.tsx";

export const OnboardingLayout = ({ children }: { children: ReactNode }) => {
  return (
    <ScrollArea className={"h-dvh w-dvw"}>
      {children}
      <HelpPopup />
    </ScrollArea>
  );
};
